import CssBaseline from "@mui/material/CssBaseline";
import React, { Component } from "react";
import "../../App.css"
import Appbar from "./AppbarTO.js";
import UserSessionTimeoutSnackbar from "../UserSessionTimeoutSnackbar";
import { removeAuthCodeFromQueryString } from "../../util/authentication.js";

export class ActiveUserSession extends Component {
  componentDidMount() {
    removeAuthCodeFromQueryString();
  }

  render() {
    return (
      <div className="root">
        <CssBaseline />
        <UserSessionTimeoutSnackbar />
        <Appbar />
      </div>
    );
  }
}

export default ActiveUserSession;